import { Job } from "../../../../../models/job";
class AddCandidatesFromJobBoardsController {
    /*@ngInject*/
    constructor($rootScope, $sce, resumeService, jobService, planService, companyService, modalService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$sce = $sce;
        this.resumeService = resumeService;
        this.jobService = jobService;
        this.planService = planService;
        this.companyService = companyService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //variables
        this.job = {};
        this.jobBoardDetails = [];
        this.requisitionDetails = {};
        this.resumePullCounts = [5, 10, 15, 20, 25];
        this.jobBoardsResumePullLeft = 0;
        this.jobBoardsPullResumePulled = 0;
        this.activeJobBoardsFilterTabNumber = 0;
        // flags
        this.isJobBoardSelected = false;
        this.isGetCandidateFetchCalled = false;
        this.isParametersEditable = true;
        this.isLoading = true;
        this.isTrialPlanActive = false;
        this.isCorporate = false;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.savingFlag = false;
        this.getPlanDetails(() => {
            if (this.isTrialPlanActive) {
                this.getJobBoardsResumePullLimits();
            }
        });
        this.getJob(() => {
            this.getAllJobBoards(() => {
                this._setJobBoardDetails();
                this.getJobBoardParameters();
            });
            this.getRequisitionDetails();
            this.getRadiusAndRecencyOptions();
        });
    }
    getPlanDetails(successCallback) {
        this.planService.getCompanyPlanDetails(this.companyId, (data) => {
            if (!_.isNull(data.features) && data.features.length) {
                this.isTrialPlanActive = data.plan == "Trial" ? true : false;
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getJobBoardsResumePullLimits() {
        this.planService.getAvailableJobBoardsPullCount(this.companyId, (data) => {
            this.jobBoardsResumePullLeft = data["jobBoardResumesLeftCount"];
            this.jobBoardsPullResumePulled = data["jobBoardResumesPulledCount"];
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getJobBoardParameters() {
        this.jobService.getJobBoardParameters((data) => {
            this.jobBoardParameters = data;
            this.parseJobBoardParameters();
            this.isLoading = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    parseJobBoardParameters() {
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (!_.isNull(val.daxtraCode)) {
                let flags = [];
                let jobBoardsParams = this.jobBoardParameters.jobBoardParameterMap[val.daxtraCode];
                flags.push(true); // location supported by all job boards
                flags.push(this._isParameterSupported(jobBoardsParams, "postcode"));
                flags.push(this._isParameterSupported(jobBoardsParams, "radius"));
                flags.push(this._isParameterSupported(jobBoardsParams, "jobType"));
                flags.push(this._isParameterSupported(jobBoardsParams, "recency"));
                flags.push(this._isParameterSupported(jobBoardsParams, "education"));
                flags.push(this._isParameterSupported(jobBoardsParams, "industry"));
                flags.push(this._isParameterSupported(jobBoardsParams, "salary"));
                val.flags = flags;
            }
        });
        this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
    }
    _isParameterSupported(jobBoardParameters, parameter) {
        return (jobBoardParameters.indexOf(parameter) == -1) ? false : true;
    }
    getJob(successCallback) {
        this.jobService.getJob(this.jobId, (data) => {
            this.job = this._parseJobResponse(data);
            successCallback(data);
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _parseJobResponse(data) {
        let tempJob = new Job();
        tempJob.id = data.id;
        tempJob.title = data.title;
        if (_.isNull(data.clientorbu)) {
            tempJob.clientorbu = null;
        }
        else {
            tempJob.clientorbu = {
                name: data.clientorbu.name,
                id: data.clientorbu.id,
                shortName: data.clientorbu.shortName
            };
        }
        tempJob.jobType = data.jobType;
        tempJob.location = data.location;
        tempJob.locationLabel = '-';
        if (!_.isNull(tempJob.location)) {
            if (!_.isNull(data.location.city)) {
                tempJob.locationLabel = data.location.city;
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.state;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.locationLabel = '-';
                }
            }
            else {
                if (!_.isNull(data.location.state)) {
                    tempJob.locationLabel += ', ' + data.location.state;
                }
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.zipcode;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.zipcode = '-';
                }
            }
            else {
                if (!_.isNull(data.location.zipcode)) {
                    tempJob.locationLabel += ', ' + data.location.zipcode;
                }
            }
        }
        tempJob.educationList = data.educationList;
        tempJob.licensePreferences = data.licensePreferences;
        tempJob.radius = data.radius;
        tempJob.recency = data.recency;
        tempJob.salary = data.salary;
        tempJob.industry = data.industry;
        tempJob.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.jobBoardDetails)) {
            angular.forEach(tempJob.jobBoardDetails, (val, key) => {
                if (_.findIndex(tempJob.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
            tempJob.resumesToPullPerJobBoardCount = tempJob.licensePreferences.resumesToPullPerJobBoardCount;
        }
        tempJob.daxtraParameters = data.daxtraParameters;
        //advanced params exist set Advanced filters tab as active
        if (!(_.isNull(data.daxtraParameters) || _.isUndefined(data.daxtraParameters)) && !(_.isNull(data.advancedParametersImage) || _.isUndefined(data.advancedParametersImage))) {
            this.activeJobBoardsFilterTabNumber = 1;
        }
        tempJob.advancedParametersImage = this.$sce.trustAsResourceUrl(data.advancedParametersImage);
        return tempJob;
    }
    getAllJobBoards(successCallback) {
        let buId = null;
        if (!_.isNull(this.job.clientorbu) && this.isCorporate) {
            buId = this.job.clientorbu.id;
        }
        this.resumeService.getResumeSourceTypes(this.companyId, buId, (data) => {
            if (data.length > 0) {
                angular.forEach(data, (val, key) => {
                    val.boardId = val.id;
                    val.enabled = true;
                    delete val.id;
                });
                this.jobBoardDetails = data;
            }
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setJobBoardDetails() {
        this.job.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(this.job.licensePreferences) && !_.isNull(this.job.licensePreferences.jobBoardDetails)) {
            angular.forEach(this.job.jobBoardDetails, (val, key) => {
                if (_.findIndex(this.job.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
        }
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (val.enabled == true) {
                this.isJobBoardSelected = true;
            }
        });
    }
    getRadiusAndRecencyOptions() {
        this.jobService.getRadiusAndRecencyOptions((data) => {
            console.log('options');
            console.log(data);
            this.radiusOptions = data.radius;
            this.recencyOptions = data.recency;
            if (_.isNull(this.job.radius)) {
                this.job.radius = data.defaultRadius[0];
            }
            if (_.isNull(this.job.recency)) {
                this.job.recency = data.defaultRecency[0];
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    checkStatusAndGetResumesFromJobBoards() {
        this.isGetCandidateFetchCalled = true;
        this.jobService.getGetMoreResumesJobStatus(this.job.id, (jobInProgress) => {
            if (jobInProgress == true) {
                this.isGetCandidateFetchCalled = false;
                this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
            }
            else {
                this.getResumesFromJobBoards();
            }
        }, (error) => {
            this.isGetCandidateFetchCalled = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getResumesFromJobBoards() {
        this.jobService.getResumesFromJobBoards(this.job.id, this.job.jobBoardDetails, this.job.resumesToPullPerJobBoardCount, this.job.radius, this.job.recency, (data) => {
            this.isGetCandidateFetchCalled = false;
            if (this.saveCallback) {
                this.saveCallback();
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                message: "Candidates are being fetched from Job Boards. You will be notified once the candidates are fetched",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }, (error) => {
            this.isGetCandidateFetchCalled = false;
            //Resume pull failed
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-times fa-fw fa-lg'></i><strong>Fail!</strong></div>",
                message: error.message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        });
    }
    getRequisitionDetails() {
        this.jobService.getRequisitionDetails(this.job.id, this.companyId, (data) => {
            this.requisitionDetails = data;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    onJobBoardSelectionChange() {
        this.isJobBoardSelected = false;
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (val.enabled == true) {
                this.isJobBoardSelected = true;
            }
        });
    }
}
AddCandidatesFromJobBoardsController.$inject = ['$rootScope', '$sce', 'resumeService', 'jobService', 'planService', 'companyService', 'modalService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-candidates-from-job-boards.html';
import * as TEMPLATE from 'raw-loader!./add-candidates-from-job-boards.html';
export const AddCandidatesFromJobBoardsComponent = {
    selector: 'addCandidatesFromJobBoards',
    component: {
        bindings: {
            jobId: '@',
            saveCallback: '&'
        },
        controller: AddCandidatesFromJobBoardsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/add-candidates-from-job-boards.html'
    }
};
//# sourceMappingURL=add-candidates-from-job-boards.component.js.map